// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Collapse from '@material-ui/core/Collapse';

import SVGIcon from '../../SVGIcon/SVGIcon';
import Table from '../../Table/Table';
import Text from '../../BuildingBlocks/Text';
import { colors } from '../../css';
import {
  StyledRoomCardWrapper,
  StyledCurrencyLine,
  StyledRoomPrice,
  StyledRoomDescDrawer,
  StyledStartingLine,
  StyledRightColumn,
  StyledLeftColumn,
  StyledNumberToggle,
  StyledHeadingText,
  StyledCapacityText,
  StyledCollapseButton,
  StyledCloseArrow,
  StyledAvailabilityText,
  StyledRoomDescription,
  StyledHideShowText,
  StyledStrikeoutPrice,
  StyledButtonRow,
  StyledInnerLeftColumn,
  StyledInnerRightColumn,
  StyledPagination,
  StyledArrowIcon,
  StyledReveal,
  StyledDivider,
  StyledSpinner,
  StyledCallForPricing,
  StyledPaneHeadingText,
  StyledPaneCapacityText,
  CallForPricingContainer
} from './Panel.styles';
import PropertyAvailability from '../../../constants/enums/PropertyAvailability';
import IgnoreTranslation from '../../Localize/ignoreTranslation';
import ToolTip from '../../ToolTip/ToolTip';

class Panel extends Component {
  static propTypes = {
    roomId: PropTypes.string,
    name: PropTypes.string,
    capacity: PropTypes.number,
    availability: PropTypes.string,
    availableRooms: PropTypes.string,
    price: PropTypes.string,
    roomDescription: PropTypes.string,
    open: PropTypes.bool,
    openText: PropTypes.string,
    closeText: PropTypes.string,
    onRoomsChange: PropTypes.func,
    currency: PropTypes.string,
    capacityText: PropTypes.string,
    startingText: PropTypes.string,
    roomsValue: PropTypes.number,
    callForPricing: PropTypes.bool,
    strikeoutPrice: PropTypes.string,
    nightlyRates: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        price: PropTypes.string
      })
    ),
    loading: PropTypes.bool,
    callForAvailabilityLabel: PropTypes.string,
    callForPricingLabel: PropTypes.string,
    callForPricingPhoneNumber: PropTypes.string,
    propertyPane: PropTypes.bool,
    canCreateBooking: PropTypes.bool,
    canCreateMultiGuestBooking: PropTypes.bool
  };

  static defaultProps = {
    roomId: undefined,
    name: undefined,
    capacity: 0,
    availability: undefined,
    availableRooms: undefined,
    price: undefined,
    roomDescription: undefined,
    open: false,
    openText: undefined,
    closeText: undefined,
    currency: undefined,
    capacityText: undefined,
    startingText: undefined,
    roomsValue: 0,
    onRoomsChange: () => {},
    callForPricing: false,
    strikeoutPrice: '',
    nightlyRates: [],
    loading: false,
    callForAvailabilityLabel: 'Please call for availability',
    callForPricingLabel: 'Please call for additional information',
    callForPricingPhoneNumber: '',
    propertyPane: false,
    canCreateBooking: false,
    canCreateMultiGuestBooking: true
  };

  constructor(props) {
    super(props);
    this.state = { open: props.open, ratePage: 0 };
    this.setRoomValue = this.setRoomValue.bind(this);
    this.toggleOpenState = this.toggleOpenState.bind(this);
    this.renderCollapseButton = this.renderCollapseButton.bind(this);
    this.shouldDisplayCallForInfo = this.shouldDisplayCallForInfo.bind(this);
  }

  setRoomValue(event) {
    const { onRoomsChange, roomId } = this.props;
    onRoomsChange(event, roomId);
  }

  toggleOpenState() {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  mapNightlyRates() {
    const { nightlyRates } = this.props;
    const { ratePage } = this.state;
    const rateMap = nightlyRates.slice(ratePage * 7, (ratePage + 1) * 7).map((rate, i) => {
      const dateFormat = 'ddd, MMM D';
      const date = moment(rate.date).format(dateFormat);
      return { id: i, date, price: rate.price };
    });
    if (nightlyRates.length > 7) {
      while (rateMap.length < 7) {
        rateMap.push({ id: rateMap.length, date: '', price: '' });
      }
    }
    return rateMap;
  }

  renderCollapseButton() {
    const { open } = this.state;
    const { openText, closeText } = this.props;
    const svgText = open ? openText : closeText;
    const buttonSVG = open ? (
      <StyledCloseArrow width="18px" selectedIcon="arrow" iconColor={colors.colorBlue} rotate={180} />
    ) : (
      <SVGIcon width="18px" selectedIcon="arrow" iconColor={colors.colorBlue} />
    );

    return (
      <StyledCollapseButton onClick={this.toggleOpenState}>
        {buttonSVG} <StyledHideShowText color="quaternary">{svgText}</StyledHideShowText>
      </StyledCollapseButton>
    );
  }

  renderPagination() {
    const { nightlyRates } = this.props;
    const { ratePage } = this.state;
    const prevDisabled = ratePage <= 0;
    const nextDisabled = ratePage >= nightlyRates.length / 7 - 1;
    return (
      <StyledPagination>
        <StyledCollapseButton
          disabled={prevDisabled}
          className={prevDisabled ? 'disabled' : ''}
          onClick={() => {
            this.setState({ ratePage: ratePage - 1 });
          }}
        >
          <StyledArrowIcon
            iconColor={prevDisabled ? colors.colorGrey04 : colors.colorBlue}
            selectedIcon="arrow"
            rotate={90}
            width="14px"
            height="14px"
          />
          <Text.CopyMini color={prevDisabled ? 'tertiary' : 'quaternary'} noMargins tagName="span">
            Prev week
          </Text.CopyMini>
        </StyledCollapseButton>
        <StyledCollapseButton
          disabled={nextDisabled}
          className={nextDisabled ? 'disabled' : ''}
          onClick={() => {
            this.setState({ ratePage: ratePage + 1 });
          }}
        >
          <Text.CopyMini color={nextDisabled ? 'tertiary' : 'quaternary'} noMargins tagName="span">
            Next week
          </Text.CopyMini>
          <StyledArrowIcon
            iconColor={ratePage >= nightlyRates.length / 7 - 1 ? colors.colorGrey04 : colors.colorBlue}
            selectedIcon="arrow"
            rotate={-90}
            width="14px"
            height="14px"
          />
        </StyledCollapseButton>
      </StyledPagination>
    );
  }

  shouldDisplayCallForInfo() {
    const { callForPricing, availability, isAdmin, propertyConnected, bookingBypassReasonId } = this.props;

    if (isAdmin) return false;

    if (callForPricing && propertyConnected && !bookingBypassReasonId) return true;

    return callForPricing && availability !== PropertyAvailability.SOLD_OUT;
  }

  determinePanelState() {
    const { availability, bookingBypassReasonId, availableRooms, canCreateBooking } = this.props;

    let availabilityText = '';
    if (availability === PropertyAvailability.SOLD_OUT) {
      availabilityText = 'SOLD-OUT - PLEASE CALL US TO BOOK';
    } else if (availability === PropertyAvailability.LIMITED) {
      availabilityText = 'limited availability';
    } else if (availability === PropertyAvailability.AVAILABLE && availableRooms) {
      availabilityText = `${availableRooms} room${availableRooms > 1 ? 's' : ''} available`;
    }

    const isAvailableOrNotSoldOut = !availability || availability !== PropertyAvailability.SOLD_OUT;
    const showRoomToggleAndNights = canCreateBooking && (isAvailableOrNotSoldOut || bookingBypassReasonId);

    const isSoldOutWithoutBypass = availability === PropertyAvailability.SOLD_OUT && !bookingBypassReasonId;
    const disabledPanel = !canCreateBooking || isSoldOutWithoutBypass;

    return { availabilityText, showRoomToggleAndNights, disabledPanel };
  }

  render() {
    const {
      name,
      capacity,
      availability,
      price,
      roomDescription,
      currency,
      capacityText,
      startingText,
      roomsValue,
      callForPricing,
      strikeoutPrice,
      nightlyRates,
      loading,
      callForPricingLabel,
      callForAvailabilityLabel,
      callForPricingPhoneNumber,
      bookingBypassReasonId,
      roomId,
      propertyPane,
      isAdmin,
      roomInputs,
      totalRoomCount,
      canCreateMultiGuestBooking
    } = this.props;
    const { open } = this.state;
    const { availabilityText, showRoomToggleAndNights, disabledPanel } = this.determinePanelState();

    // This is intended for the self booker role to restrict them from selecting more than 1 room when creating a booking
    const restrictSelectedRoomsIfNotPermitted =
      !canCreateMultiGuestBooking && Object.keys(roomInputs)?.length && !roomInputs?.[roomId] && totalRoomCount > 0;

    const disableToggle =
      (!isAdmin && callForPricing && !bookingBypassReasonId) ||
      (availability === PropertyAvailability.SOLD_OUT && !bookingBypassReasonId) ||
      restrictSelectedRoomsIfNotPermitted;

    return (
      <StyledRoomCardWrapper status={disabledPanel}>
        <StyledLeftColumn propertyPane={propertyPane} shouldDisplayCallForInfo={this.shouldDisplayCallForInfo()}>
          <div>
            {propertyPane ? (
              <>
                <StyledPaneHeadingText noMargins>{name}</StyledPaneHeadingText>
                <StyledPaneCapacityText noMargins>
                  {capacityText}: {capacity}
                </StyledPaneCapacityText>
              </>
            ) : (
              <>
                <StyledHeadingText noMargins>{name}</StyledHeadingText>
                <StyledCapacityText noMargins>
                  {capacityText}: {capacity}
                </StyledCapacityText>
              </>
            )}
          </div>
          {this.shouldDisplayCallForInfo() && (
            <ToolTip content="Click chat bubble in the bottom right">
              <StyledCallForPricing>
                <Text.CopyParagraph weight="bold" tagName="span" color="quaternary">
                  {callForPricingLabel}
                </Text.CopyParagraph>
              </StyledCallForPricing>
            </ToolTip>
          )}
          {!this.shouldDisplayCallForInfo() && (
            <>
              <StyledStartingLine noMargins color="tertiary">
                {startingText}
                {strikeoutPrice && !loading && (
                  <StyledStrikeoutPrice noMargins tagName="span">{`${strikeoutPrice}`}</StyledStrikeoutPrice>
                )}
              </StyledStartingLine>
              <StyledRoomPrice align="left" noMargins propertyPane={propertyPane}>
                {loading ? <StyledSpinner size={18} thickness={6} /> : price}
              </StyledRoomPrice>
              <StyledCurrencyLine noMargins color="tertiary" align="left">
                {currency}
              </StyledCurrencyLine>
            </>
          )}
        </StyledLeftColumn>
        {!disableToggle && (
          <StyledRightColumn propertyPane={propertyPane}>
            {availability === PropertyAvailability.SOLD_OUT && !isAdmin ? (
              <>
                <Text.CopyMini noMargins tagName="div" textTransform="uppercase" weight="bold" align="center">
                  {callForAvailabilityLabel}
                </Text.CopyMini>
                <CallForPricingContainer>
                  <Text.CopyParagraph noMargins weight="bold" tagName="span" color="quaternary" align="center">
                    {callForPricingPhoneNumber}
                  </Text.CopyParagraph>
                </CallForPricingContainer>
              </>
            ) : null}
            {!availability === PropertyAvailability.SOLD_OUT && availabilityText.length && !isAdmin ? (
              <StyledAvailabilityText status={availability} textTransform="uppercase" noMargins tagName="span">
                {availabilityText}
              </StyledAvailabilityText>
            ) : null}
            {showRoomToggleAndNights && (
              <IgnoreTranslation>
                <StyledNumberToggle
                  min={0}
                  max={canCreateMultiGuestBooking ? 5000 : 1}
                  value={roomsValue}
                  onChange={this.setRoomValue}
                  disabled={disableToggle}
                  propertyPane={propertyPane}
                />
              </IgnoreTranslation>
            )}
          </StyledRightColumn>
        )}
        {showRoomToggleAndNights && (
          <StyledRoomDescDrawer>
            <Collapse in={open}>
              {callForPricing && !isAdmin ? (
                <StyledRoomDescription propertyPane={propertyPane}>{roomDescription}</StyledRoomDescription>
              ) : (
                <StyledReveal>
                  <StyledInnerLeftColumn>
                    <StyledRoomDescription bold>Nightly Rates</StyledRoomDescription>
                    {loading ? (
                      <StyledSpinner size={16} thickness={6} />
                    ) : (
                      <div>
                        {nightlyRates.length > 0 ? (
                          <>
                            <Table
                              rowStyles={{ height: '24px' }}
                              rows={[{ id: 'date', label: '' }, { id: 'price', label: '' }]}
                              minTableWidth="100%"
                              showHeader={false}
                              contentCellsConfig={{
                                date: {
                                  numeric: false,
                                  style: { fontSize: '0.875rem', paddingLeft: 0, paddingRight: 10 }
                                },
                                price: {
                                  numeric: true,
                                  style: { fontSize: '0.875rem', paddingLeft: 0, paddingRight: 10 }
                                }
                              }}
                            >
                              {this.mapNightlyRates()}
                            </Table>
                            {nightlyRates.length > 7 && this.renderPagination()}
                          </>
                        ) : (
                          <StyledRoomDescription>No Rates</StyledRoomDescription>
                        )}
                      </div>
                    )}
                  </StyledInnerLeftColumn>
                  <StyledDivider />
                  <StyledInnerRightColumn>
                    {roomDescription && <StyledRoomDescription bold>Room Description</StyledRoomDescription>}
                    <StyledRoomDescription>{roomDescription}</StyledRoomDescription>
                  </StyledInnerRightColumn>
                </StyledReveal>
              )}
            </Collapse>
            <StyledButtonRow>{this.renderCollapseButton()}</StyledButtonRow>
          </StyledRoomDescDrawer>
        )}
      </StyledRoomCardWrapper>
    );
  }
}

export default Panel;
